import { Component } from "@angular/core";
import { StatusService } from "../status.service";

@Component({
  selector: "app-master-summary",
  templateUrl: "./master_summary.component.html",
  styleUrls: [
    "./master_summary.component.css",
    "../master_status.component.css",
  ],
})
export class Master_SummaryComponent {
  filter = {
    fromDate: "",
    toDate: "",
  };

  summaryList: any[] = [];
  dataLoaded = false; // flag to show/hide "No data found"

  constructor(private statusService: StatusService) {}

  filterByDate() {
    if (this.filter.fromDate && this.filter.toDate) {
      this.statusService
        .getSummary(this.filter.fromDate, this.filter.toDate)
        .subscribe({
          next: (response) => {
            if (response?.status === "1" && response?.data?.processes) {
              this.summaryList = response.data.processes;
              this.dataLoaded = true;
            } else {
              this.summaryList = [];
              this.dataLoaded = false;
            }
          },
          error: () => {
            this.summaryList = [];
            this.dataLoaded = false;
          },
        });
    }
  }
}
